import { TreeRange } from "./Range";

export default class HtmlRangeClient {
  readonly route = "/range";
  readonly batchRoute = "/ranges";

  constructor(readonly baseUrl: string) {}

  async batchTranslateRanges(
    html: string,
    ranges: { offset: number; length: number }[]
  ): Promise<TreeRange[]> {
    const response = await fetch(this.baseUrl + this.batchRoute, {
      method: "POST",
      body: JSON.stringify({
        html,
        highlights: ranges,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.json();
  }

  /**
   * @deprecated use batchTranslateRanges
   */
  async translateRange(
    html: string,
    offset: number,
    length: number
  ): Promise<TreeRange> {
    const response = await fetch(this.baseUrl + this.route, {
      method: "POST",
      body: JSON.stringify({
        html,
        highlight: {
          offset,
          length,
        },
      }),
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.json();
  }
}
